import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fa from "./fa.json";
import en from "./en.json";

let lang = document.cookie
  .split("; ")
  .find((row) => row.startsWith("language="))
  ? document.cookie
      .split("; ")
      .find((row) => row.startsWith("language="))
      .split("=")[1]
  : "en";

i18n.use(initReactI18next).init({
  resources: {
    fa: {
      translation: fa,
    },
    en: {
      translation: en,
    },
  },

  lng: lang,
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
